import React from 'react';
import classNames from 'classnames';

// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import styles from './Loader.module.scss';

const Loader = ({ position = 'center' }) => (
    <div
        className={classNames(styles['Loader'], {
            [styles['Loader--Left']]: position === 'left',
            [styles['Loader--Right']]: position === 'right',
        })}>
        <div className={styles['Loader__Indicator']} />
        <div className={styles['Loader__Indicator']} />
    </div>
);

Loader.propTypes = {
    position: PropTypes.oneOf(['left', 'center', 'right']),
};

export default Loader;
